import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
//import { HttpModule } from '@angular/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeFr);

import { ToastrModule } from 'ngx-toastr';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from '../router/router.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppComponent } from './app.component';
import { SortablejsModule } from 'ngx-sortablejs';

import { LanguageService } from "../services/language.service";
import { AuthService } from "../services/auth.service";
import { AuthGuard } from "../services/auth-guard";
import { ContractorService } from "../services/contractor.service";
import { TemplateService } from "../services/template.service";
import { AuditTrailService } from "../services/audittrail.service";
import { EventNotificationService } from "../services/event_notification.service";
import { FileService } from "../services/file.service";
import { FileTypeService } from "../services/fileType.service";
import { HttpClientService } from "../services/httpClient.service";
import { JobService } from "../services/job.service";
import { MessageService } from "../services/message.service";
import { NotificationService } from "../services/notification.service";
import { PersonService } from "../services/person.service";
import { PIDService } from "../services/pid.service";
import { ProfileService } from "../services/profile.service";
import { UserService } from "../services/user.service";
import { FileTableService } from "../services/filetable.service";
import { PidTableService } from "../services/pidtable.service";
import { UtilsService } from "../services/utils.service";
import { SearchbarService } from "../services/searchbar.service";
import { DatePipe } from '@angular/common';

import { ProfileComponent } from "../components/profile/profile.component";
import { ContractorComponent } from "../components/contractor/contractor.component";
import { TemplateComponent } from "../components/template/template.component";
import { AuditTrailComponent } from "../components/audittrail/audittrail.component";
import { SenderComponent } from "../components/sender/sender.component";
import { AuthComponent } from "../components/auth/auth.component";
import { PIDComponent } from "../components/pid/pid.component";
import { MassEditDialog } from "../components/massedit/massedit.component";

import { FileDetailsComponent } from "../components/file-details/file-details.component";
import { ExpiredComponent } from "../components/expired/expired.component";
import { ForgotPasswordComponent } from "../components/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "../components/reset-password/reset-password.component";
import { ContractorUploadComponent } from "../components/contractor-upload/contractor-upload.component";
import { ViewFileComponent } from "../components/view-file/view-file.component";
import { AdministrationComponent } from "../components/admin/admin.component";
import { TransferComponent } from "../components/transfer/transfer.component";
import { HomeComponent } from "../components/home/home.component";

import { PIDTransferComponent } from "../components/shared/pid-transfer.component";

import { MatInputModule } from "@angular/material/input";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatIconModule } from "@angular/material/icon";
import { MatRadioModule } from "@angular/material/radio";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatListModule } from '@angular/material/list';
import { MatChipsModule } from '@angular/material/chips';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSelectModule } from '@angular/material/select';
import { MessageAdminComponent } from "../components/message-admin/message-admin.component";
import { ModalComponent } from "../components/modal/modal.component";
import { FSModalComponent } from "../components/fsmodal/fsmodal.component";
import { NestasSearchbarComponent } from "../components/searchbar/searchbar.component";
import { NestasToolbarComponent } from "../components/toolbar/toolbar.component";
import { NestasPIDInfoComponent } from "../components/toolbar/pidinfo.component";
import { NestasLangComponent } from "../components/lang/lang.component";
import { MessageComponent } from "../components/message/message.component";
import { ContactComponent } from "../components/contact/contact.component";
import { PreviewComponent } from "../components/preview/preview.component";
import { NestasNewFileComponent } from "../components/new-file/new-file.component";
import { NestasNewPIDComponent } from "../components/new-pid/new-pid.component";
import { NestasPIDCardComponent } from "../components/pid-card/pid-card.component";
import { PIDTableComponent } from "../components/pid-table/pid-table.component";
import { FileTableComponent } from "../components/file-table/file-table.component";
import { HomeResolve } from "../components/home/home.resolve";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MomentModule } from "ngx-moment";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ModalFrameComponent } from "../components/modal-frame/modal.frame.component";
import { MatGridListModule } from '@angular/material/grid-list';
import { MAT_RIPPLE_GLOBAL_OPTIONS, RippleGlobalOptions } from '@angular/material/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { CookieService } from 'ngx-cookie-service';
import { NgxGalleryModule } from '@kolkov/ngx-gallery';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, 'i18n/', '.json');
}

const globalRippleConfig: RippleGlobalOptions = {
  disabled: true
};

@NgModule({
  declarations: [
    AppComponent,
    ProfileComponent,
    ContractorComponent,
    TemplateComponent,
    AuditTrailComponent,
    SenderComponent,
    AuthComponent,
    PIDComponent,
    MassEditDialog,
    FileDetailsComponent,
    ExpiredComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    ContractorUploadComponent,
    ViewFileComponent,
    AdministrationComponent,
    HomeComponent,
    TransferComponent,
    PIDTransferComponent,
    NestasSearchbarComponent,
    NestasToolbarComponent,
    NestasPIDInfoComponent,
    ModalComponent,
    FSModalComponent,
    MessageAdminComponent,
    NestasLangComponent,
    PreviewComponent,
    ContactComponent,
    MessageComponent,
    NestasNewFileComponent,
    NestasPIDCardComponent,
    PIDTableComponent,
    FileTableComponent,
    NestasNewPIDComponent,
    ModalFrameComponent
  ],
  imports: [
    NgxDatatableModule,
    BrowserModule,
    //HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    //EllipsisModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    MatInputModule,
    MatSelectModule,
    MatCardModule,
    MatButtonModule,
    MatCheckboxModule,
    MatIconModule,
    MatProgressBarModule,
    MatRadioModule,
    MatSidenavModule,
    MatTabsModule,
    MatToolbarModule,
    MatProgressSpinnerModule,
    MatListModule,
    MatGridListModule,
    MomentModule,
    MatTooltipModule,
    MatChipsModule,
    MatMenuModule,
    MatDialogModule,
    MatExpansionModule,
    MatSlideToggleModule,
    SortablejsModule.forRoot({ animation: 150 }),
    NgxGalleryModule 
  ],
  entryComponents: [
    MassEditDialog
  ],
  providers: [
    LanguageService,
    HomeResolve,
    AuthGuard,
    AuthService,
    ContractorService,
    TemplateService,
    AuditTrailService,
    EventNotificationService,
    FileService,
    FileTypeService,
    HttpClientService,
    JobService,
    MessageService,
    NotificationService,
    PersonService,
    PIDService,
    ProfileService,
    SearchbarService,
    UserService,
    FileTableService,
    PidTableService,
    UtilsService,
    DatePipe,
    CookieService,
    { provide: LOCALE_ID, useValue: "fr-BE" },
    { provide: MAT_RIPPLE_GLOBAL_OPTIONS, useValue: globalRippleConfig }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
